module.exports = __webpack_public_path__ + "img/1x1_border.ec3e54d1.jpg";